// 261010 UI-directing — dòng «Đạo diễn cần thêm N tài sản — Xem ở Tài sản». Không có việc cho người ⇒ không vẽ gì. Luật: directingTailPolicy.ts.
import React from 'react';
import type { WorkflowStatus } from '../../types/filmWorkflow';
import { directingTailLineOf } from './directingTailPolicy';
import WfIcon from './WfIcon';

const WorkflowDirectingTailLine: React.FC<{ status: WorkflowStatus; onGoAssets: () => void }> = ({ status, onGoAssets }) => {
  const line = directingTailLineOf(status);
  if (!line) return null;
  return (
    <p className="wf-failline warn" role="status" data-testid="wf-directing-tail">
      <span className="wf-si warn"><WfIcon name="warning" /></span>
      <span className="t">{line.text} — <button type="button" className="wf-plink" onClick={onGoAssets} data-testid="wf-directing-tail-go">Xem ở Tài sản</button></span>
    </p>
  );
};

export default WorkflowDirectingTailLine;
